import { Component, AfterViewInit, OnInit, ViewChild, ElementRef, HostListener, ChangeDetectorRef, NgModule, OnDestroy  } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first, map, delay, startWith } from 'rxjs/operators';

import { AlertService, ExamService, OpentokService } from '../_services';
import { Globals } from '../_helpers';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
//import { Subject } from 'rxjs';
import { Subject, Observable, throwError, combineLatest, timer, Subscription, interval } from 'rxjs';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';

import * as OT from '@opentok/client';
import config from '../../config';

const publish = () => {

};
export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}



@Component({
    selector: 'psychometric-wls-test',
    templateUrl: './psychometric.component.html',
    styleUrls: ['./psychometric.component.css'],
    providers: [OpentokService]
})

export class PsychometricWlsComponent implements AfterViewInit, OnInit {
    @ViewChild('optionsubmitSwal') private optionsubmitSwal: SwalComponent;
    @ViewChild('optionsubmitconfirmSwal') private optionsubmitconfirmSwal: SwalComponent;
    @ViewChild('examsubmitconfirmSwal') private examsubmitconfirmSwal: SwalComponent;
    @ViewChild('timeoverSwal') private timeoverSwal: SwalComponent;
    @ViewChild('noanyanswerSwal') private noanyanswerSwal: SwalComponent;
    @ViewChild('mandatorySwal') private mandatorySwal: SwalComponent;
    @ViewChild('bgWarningSwal') private bgWarningSwal: SwalComponent;
    @ViewChild('checkedSwal') private checkedSwal: SwalComponent; 
    @ViewChild('randomAlertSwal') private randomAlertSwal: SwalComponent;
    @ViewChild('warningCameraSwal') private warningCameraSwal: SwalComponent;

    public alertOption: SweetAlertOptions = {};
    private intervalSubscription: Subscription;    

    matcher = new MyErrorStateMatcher();

    @HostListener('window:keyup', ['$event'])
    onKeyupHandler(event: KeyboardEvent) {
        if (event.keyCode == 123 || event.keyCode == 122)
            //this.autoSubmitAnswers('manual');
            /*console.log(event.keyCode);*/
            event.stopPropagation();
    }

    studentName: string = '';
    studentCode: string = '';
    optionIndexText = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
    answerdObj = {};
    notSubmitObj = [];
    answeredQuestObj = [];
    questArr = [];
    loading = false;
    indexClasses: string;
    timershow: string;
    returnUrl: string;
    maxMarks: number;
    duration: number = 0;
    type: string;
    totalQuestion: number;
    question: string;
    questionInst: string;
    index: number = 1;
    answer_id: number;
    question_id: number;
    deficulty_lebel: number = 0;
    userData = {};
    settings = {};
    options = [];
    distance: any;
    totalAnswered: number = 0;
    totalSubmited: number = 0;
    totalVisited: number = 0;
    totalNotAnswered: number = 0;
    interval;
    intervaltime;
    settime;
    isPause = false;
    isResetBtn = false;
    visitedQuesObj = {};
    isSubmit = false;
    isPauseBtn = false;
    instructions = [];
    nativeWindow: any;
    totalTimeTake: number = 0;
    timeTaken: number = 0;
    totalExamTime;
    prevques = [];

    isMedia = false;
    qaudioUrl: string = '';
    qvideoUrl: string = '';
    qimageUrl: string = '';
    ssclogo: string = '';
    surveyUrl: string = '';
    isPicTaken;
    imagePath;
    noofpic: number = 0;
    isDone = true;
    isSpeech = true;
    speechLang = 'en-GB';
    prevIndex: number = 1;
    lock_status = 0;
    spendTime: number = 0;
    remain_minute: number 
    bg_count: number = 0;
    nos;
    subject;
    randomPhoto;
    apiinterval;
    freezestatus: number = 0;
    isTextConversion = false;
    randomtext:string = "";  
    mockExam: number = 0;  
    userInfo: {};
    studentidself:number = 0;
    profilepic: string = '/assets/images/profile.png';
    optArr = [];  
    optCheckedArr = [];  
    answerString: string = '';    
    warningStatus: string = 'Warning - Your photos are capturing during an exam.';

    /* Chart Variable */
    //public pieChartLabels: string[] = ['Answered', 'Submitted', 'Visitted', 'Not attempted'];
    public pieChartLabels: string[] = ['Attempted', 'Not Attempted'];
    public pieChartData: number[] = [];
    public pieChartType: string = 'pie';
    public pieChartLegend = false;
    public chartColors: any[] = [{
        //backgroundColor: ["#44e51e", "#FF7272", "#ce03dc", "#c4c4c4"]
        backgroundColor: ["#2B8B14", "#c4c4c4"]
    }];

    /* webcam Settings */
    public showWebcam = true;
    public allowCameraSwitch = true;
    public multipleWebcamsAvailable = false;
    public deviceId: string;

    @HostListener('document:visibilitychange', ['$event'])
    visibilitychange() {
        this.settings = JSON.parse(sessionStorage.pkshn_exam_set);
        if(this.freezestatus == 0 )
        {
            if(this.bg_count <= this.settings['bg_count'])
            {     
              if (document.hidden){
                  this.bg_count ++;
                    //console.log("Page is hidden" + this.bg_count);
                    this.bgWarningSwal.show();
                    this.saveBGlog('background');
              } else {
                    this.saveBGlog('foreground');
                   // console.log("Page is visible");
              }
            }
            else
            {
                clearInterval(this.interval);
                sessionStorage.setItem('pkshn_exam_time','0:0');
                this.openSubmitArea();
                this.submitFinalExam('auto');
                this.globals.isExamOver = true;               
            } 
        }
    }

    /*public videoOptions: MediaTrackConstraints = {
    // width: {ideal: 1024},
    // height: {ideal: 576}
    };
    public errors: WebcamInitError[] = [];

    // latest snapshot
    public webcamImage: WebcamImage = null;

    // webcam snapshot trigger
    private trigger: Subject<void> = new Subject<void>();

    // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
    private nextWebcam: Subject<boolean|string> = new Subject<boolean|string>();*/


    /*open tok */
    session: OT.Session;
    //streams: Array<OT.Stream> = [];
    changeDetectorRef: ChangeDetectorRef;
    publisher: OT.Publisher;
    sessionid: string = '';
    token: string = '';
    @ViewChild('publisherDiv') publisherDiv: ElementRef;
    publishing: Boolean;
    feedsettings: {};
    isCamDisable: boolean = false;
    autoSubmitReason: string = '';
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private examService: ExamService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private domSanitizer: DomSanitizer,
        private ref: ChangeDetectorRef,
        private opentokService: OpentokService,
        private http: HttpClient        
    ) {
        this.changeDetectorRef = ref;
        this.publishing = false;
    }

    ngOnInit() {
        var step = this.route.snapshot.paramMap.get("step");
        this.userInfo = JSON.parse(localStorage.getItem('userinfo_ps'));
        if (this.userInfo != undefined) 
        {
            this.profilepic = this.userInfo['profile_pic'];
            if(this.profilepic == '')
            {
              this.profilepic = '/assets/images/profile.png';  
            }
            this.mockExam = 1;
        }
        else
        {
            this.profilepic = '/assets/images/profile.png';
        } 
        if (this.globals.isExamOver)
        {
            if (this.userInfo == undefined) 
            {
                this.studentidself = 0;
                this.router.navigateByUrl('/userlogin');
            }
            else
            {
                this.studentidself = 1;
                this.router.navigateByUrl('/dashboard');
            } 
        }
        //this.requestFullscreen(document.documentElement);

        this.userData = JSON.parse(localStorage.getItem('currentUser'));
        this.settings = JSON.parse(sessionStorage.pkshn_exam_set);
        this.feedsettings = JSON.parse(sessionStorage.pkshn_feedsetting);        
        this.studentName = this.userData['name'];
        this.studentCode = this.userData['code'];
        if (this.settings['submit'] == 0) {
            this.isSubmit = true;
        }
        if (this.settings['student_pause'] == 0) {
            this.isPauseBtn = true;
        }
        if (this.settings['text_speech'] == 0) {
            this.isSpeech = false;
        }
        if (this.settings['exam_logo'] != "") {
            this.ssclogo = this.settings['exam_logo'];
        }
        if (this.settings['exam_survey'] != "") {
            this.surveyUrl = this.settings['exam_survey'];
        }
        if (this.settings['text_conversion'] == 1) {
          this.isTextConversion = true;
        }        
        /* call function for first question and exam info */
        this.getExams();            

        this.apiinterval = setInterval(() => {
            this.theoryStausFreeze(); 
        }, 15000);
        if(this.isTextConversion == true)
        {
         this.getSecondaryLang();     
        } 

        //var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var possible = "0123456789";
        for (var i = 0; i < 5; i++)
            this.randomtext += possible.charAt(Math.floor(Math.random() * possible.length));          
        // get return url from route parameters or default to '/'
        this.returnUrl = '/';

        /*WebcamUtil.getAvailableVideoInputs()
        .then((mediaDevices: MediaDeviceInfo[]) => {
            this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
        });*/

        if (this.settings['video'] == 1) {
            // this.opentokService.initSession(this.TOKEN, this.SESSION_ID);
/*            this.opentokService.initSession();
            const OT = this.opentokService.getOT();
            this.publisher = OT.initPublisher(this.publisherDiv.nativeElement, { insertMode: 'append', width: 50, height: 40 });
            this.globals.publisherObj = this.publisher;
            if (this.session) {
                if (this.session['isConnected']()) {
                    this.publish();
                }
                this.session.on('sessionConnected', () => this.publish());
            }*/
        }
        this.intervalSubscription = interval(5000).subscribe(() => {
            var publishObj = this.globals.publisherObj;
            //var publisherObj = this.publisher;
            console.log('publishObj.accessAllowed 1 - ', publishObj.accessAllowed);
            var imgDataCam = this.publisher.getImgData();
            if(imgDataCam === null)
            {
                this.isCamDisable = true;
                this.warningCameraSwal.show(); 
                this.autoSubmitReason = 'You have not enabled your camera. Your exam is auto submitted now.';
                this.camDisableCnt = this.camDisableCnt + 1;
                if((this.camDisableCnt >= 2) && this.settings['camera_enable'] != 0)
                {
                    this.setExamLogAutoSubmit(1);
                }    
                return;            
            } 
            else
            {
                if((this.nofaceCnt >= this.settings['no_face_limit']) && this.settings['no_face_limit'] != 0)
                {
                    this.setExamLogAutoSubmit(3);
                }
                else if((this.multifaceCnt >= this.settings['multiple_face_limit']) && this.settings['multiple_face_limit'] != 0)
                {
                    this.setExamLogAutoSubmit(2);
                }
                else if((this.objectCnt >= this.settings['object_detection_limit']) && this.settings['object_detection_limit'] != 0)
                {
                    this.setExamLogAutoSubmit(5);
                }    
                else if((this.profieMatchCnt >= this.settings['profile_not_match_limit']) && this.settings['profile_not_match_limit'] != 0)
                {
                    this.setExamLogAutoSubmit(4);
                }
                else if((this.eyeBallCnt >= this.settings['eyeball_movement_limit']) && this.settings['eyeball_movement_limit'] != 0)
                {
                    this.setExamLogAutoSubmit(6);
                }        
                return; 
            }
        });        
    }
      publish() {
        this.session.publish(this.publisher, (err) => {
          if (err) {
            console.log(err)
          }
          else {
            this.publishing = true;
          }
        });
      }
  ngAfterViewInit(): void {  
            this.publisher = OT.initPublisher
              (
                this.publisherDiv.nativeElement, {
                height: "50px",
                width: "50px",
                insertMode: 'before'
              });
              this.globals.publisherObj = this.publisher;
            //var props = {connectionEventsSuppressed: true};
            this.session = OT.initSession(config.API_KEY, this.feedsettings['sessid']);
            this.session.connect(this.feedsettings['toid'], (err) => {
              if (err) {
                 console.log(err);
              }
              else {
                console.log("connected");
                this.publish()
                let that = this;
                 this.session.on("sessionDisconnected", function (event) {
                  console.log("The publisher disconnect streaming"); 
    /*              this.publisher.publishAudio(false); 
                  this.publisher.publishVideo(false); */
                  //subscribeToVideo(false)      
                });                        
              }
            }); 
/*            this.publisher.on('streamCreated', function (event) {
                console.log('The publisher started streaming.');
            });  
             this.publisher.on("streamDestroyed", function (event) {
              console.log("The publisher stopped streaming. Reason: "
                + event.reason);
            });*/ 

    timer(3 * 60 * 1000).subscribe(() => {
        var imgDataCam = this.publisher.getImgData();
        if(imgDataCam === null)
        {
            this.isCamDisable = true;
            this.warningCameraSwal.show(); 
            this.autoSubmitReason = 'You have not enabled your camera. Your exam is auto submitted now.';
            this.camDisableCnt = this.camDisableCnt + 1;
            if((this.camDisableCnt >= 2) && this.settings['camera_enable'] != 0)
            {
                this.setExamLogAutoSubmit(1);
            }    
            return;            
        } 
        else
        {
            if((this.nofaceCnt >= this.settings['no_face_limit']) && this.settings['no_face_limit'] != 0)
            {
                this.setExamLogAutoSubmit(3);
            }
            else if((this.multifaceCnt >= this.settings['multiple_face_limit']) && this.settings['multiple_face_limit'] != 0)
            {
                this.setExamLogAutoSubmit(2);
            }
            else if((this.objectCnt >= this.settings['object_detection_limit']) && this.settings['object_detection_limit'] != 0)
            {
                this.setExamLogAutoSubmit(5);
            }    
            else if((this.profieMatchCnt >= this.settings['profile_not_match_limit']) && this.settings['profile_not_match_limit'] != 0)
            {
                this.setExamLogAutoSubmit(4);
            }
            else if((this.eyeBallCnt >= this.settings['eyeball_movement_limit']) && this.settings['eyeball_movement_limit'] != 0)
            {
                this.setExamLogAutoSubmit(6);
            }        
            return; 
        }        
    });                                
  } 

    /*public triggerSnapshot(): void {
        this.trigger.next();
        this.imagePath = this.webcamImage.imageAsDataUrl;
        this.isPicTaken = false;
    }*/

    /* public toggleWebcam(): void {
         this.showWebcam = !this.showWebcam;
     }*/

    /*public handleInitError(error: WebcamInitError): void {
        this.errors.push(error);
    }*/

    /*public showNextWebcam(directionOrDeviceId: boolean|string): void {
        // true => move forward through devices
        // false => move backwards through devices
        // string => move to device with given deviceId
        this.nextWebcam.next(directionOrDeviceId);
    }*/

    /*public handleImage(webcamImage: WebcamImage): void {
        this.webcamImage = webcamImage;
    }*/

    /*public cameraWasSwitched(deviceId: string): void {
        this.deviceId = deviceId;
    }*/

    /*public get triggerObservable(): Observable<void> {
        return this.trigger.asObservable();
    }*/

    /*public get nextWebcamObservable(): Observable<boolean|string> {
        return this.nextWebcam.asObservable();
    }*/

    /*public webCameScreen(): void{
        this.isPicTaken = true;
    }*/

    secondaryLang:string = '';
    primarylang;
    seclang_code: string = '';
    selected:string;
    currentlanguage: string;
    gstringExp = [];
    optionData:any;
    originalQuestion:string;  

    secondaryLanguage(value) {
    this.secondaryLang = value;
    this.seclang_code = this.secondaryLang.split("-")[0];
    if(this.currentlanguage != this.seclang_code)
    {   
      this.currentlanguage = this.seclang_code;
      this.googleAPI(this.primary_lang_code, this.seclang_code);
    }
    }  
    primaryLanguage() {
    if(this.currentlanguage != this.primary_lang_code)
    {
      this.currentlanguage = this.primary_lang_code;
      this.googleAPI(this.seclang_code,this.primary_lang_code);
    }
    this.selected = 'Select a language';
    }   
    googleAPI(primary_lang, secondary_land)
    {
    this.loading = true;
    this.spinner.show(); 
    var gapikey = 'AIzaSyBobH9FTqp_npqwcgDlwjeKAZse_v_yp6Q';
    const body = { q: this.allOptions, source: primary_lang, target:secondary_land };
    const headers = { 'Authorization': gapikey };
    this.http.post<any>("https://translation.googleapis.com/language/translate/v2?key=AIzaSyBobH9FTqp_npqwcgDlwjeKAZse_v_yp6Q", body).subscribe((res: any) => {
    //this.http.post<any>("https://translation.googleapis.com/language/translate/v", body, { headers }).subscribe((res: any) => {
        var translateRes = res; 
        var getResponse = translateRes.data.translations; 
        for (var g = 0; g < getResponse.length; g++) 
        {
          this.gstringExp[g] = getResponse[g].translatedText;  
          this.question = this.gstringExp[0];
          this.convertOptionsObj(this.optionData);
          this.loading = false;
          this.spinner.hide();         
        }
    });
    }
    /* Get Exam data when exam UI is load */
    private getExams() {
        this.loading = true;
        this.spinner.show();
        this.options = [];
        this.questArr = [];
        this.answerdObj = {};
        this.isMedia = false;
        this.qaudioUrl = '';
        this.qvideoUrl = '';
        this.qimageUrl = '';
        this.examService.getFirstQuestion(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.settings['shuffle_ans'], this.settings['shuffle_ques'], this.settings['auto'], this.settings['theory2_login'], this.settings['entered_psyc'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        let exam = data.exams;
                        // this.duration = exam.duration;
                        this.spendTime = exam.stime;
                        this.type = exam.type;
                        this.totalQuestion = exam.totalq;
                        this.subject = exam.qp;                        
                        this.prevques = exam.res;
                        let questionData = exam.question;
                        let videoFeed = exam.feed;
                        this.answer_id = 0;
                        this.speechLang = questionData.lang;
                        //this.question = questionData.question;
                        this.question = this.originalQuestion = questionData.question; 
                        this.allOptions[0] = this.originalQuestion;
                        this.questionInst = questionData.question_inst;
                        this.maxMarks = questionData.max_marks;
                        this.question_id = questionData.question_id;
                        this.nos = questionData.nos;                        
                        if (this.spendTime > 0) {
                            this.spendTime = Math.ceil(this.spendTime / 60);
                            this.duration = (exam.duration - this.spendTime);
                        }
                        else {
                            this.duration = exam.duration;
                        }
                        //console.log(videoFeed);
                        //this.SESSION_ID = videoFeed.session;
                        //this.TOKEN = videoFeed.token;
                        //console.log(this.TOKEN);
                        //console.log(this.SESSION_ID);
                        if (questionData.media != '') {
                            this.isMedia = true;
                            if (questionData.media_type == 2) {
                                this.qimageUrl = questionData.media;
                            }
                            else if (questionData.media_type == 3) {
                                this.qaudioUrl = questionData.media;
                            }
                            else if (questionData.media_type == 4) {
                                this.qvideoUrl = questionData.media;
                            }
                        }
                        /* set button background color */
                        this.btnStyle(1, 'current');

                        /* Set question visited */
                        this.visitedQuesObj[1] = 'visited';

                        /* Create Option obj */
                        this.createOptionsObj(questionData.options);
                        this.optionData = questionData.options;

                        if(this.isTextConversion == true)
                        {
                            if(this.currentlanguage != this.primary_lang_code)
                            {
                                this.googleAPI(this.primary_lang_code, this.seclang_code);
                            }               
                        }

                        /* Create array for question index */
                        this.createArrayQuesNoObj(this.totalQuestion, this.prevques);

                        /* Set counter */
                        if (sessionStorage.getItem("pkshn_exam_time") === undefined || sessionStorage.getItem("pkshn_exam_time") === null) {
                            this.counter(this.duration);
                        }
                        else {
                            var exam_seconds = Number(this.duration) * 60;
                            var timePass = sessionStorage.getItem("pkshn_exam_time");
                            var timesplits = timePass.split(":");
                            var min = Number((Math.round(Number(timesplits[0]) * 100) / 100).toFixed(2));
                            var sec = (Number(timesplits[1]) / 60);
                            var sec1 = Number(sec.toFixed(2));
                            if(min <= 0)
                            {
                              this.remain_minute = (Number(timesplits[1]) / 100);
                            }
                            else{
                            this.remain_minute = min + sec1;               
                            }              
                            this.counter(this.remain_minute);
                        }

                        /* Timer Start for random pic*/
                        // this.takePicWithTimer(1);

                        /* Timer for per question */
                        this.questionAnswerTimer(questionData.time_taken);

                        /* Live Streaming */
                        //this.setliveStreaming(videoFeed);                    

                        let inst = (data.instruction).split('\n');
                        for (var i = 0; i < inst.length; ++i) {
                            let html = inst[i];
                            if (html != '')
                                this.instructions[i] = { index: i + 1, text: html };
                        }
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                        this.spinner.hide();
                    }
                    else {
                        this.loading = false;
                        //this.router.navigateByUrl('/login');
                        this.spinner.hide();
                    }

                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
            );
    }

    /* Get Exam data by index number */
    private getQuestionByIndex() {
        this.options = [];
        this.loading = true;
        this.isMedia = false;
        this.qaudioUrl = '';
        this.qvideoUrl = '';
        this.qimageUrl = '';
        this.spinner.show();
        this.examService.getQuestionByIndex(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.index, this.deficulty_lebel, this.prevIndex, this.timeTaken, this.settings['shuffle_ans'], this.settings['shuffle_ques'], this.settings['auto'], this.settings['theory2_login'], this.settings['entered_psyc'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        clearInterval(this.intervaltime);
                        this.prevIndex = this.index;
                        let questionData = data.question;
                        //let videoFeed = exam.feed;
                        this.speechLang = questionData.lang;
                        //this.question = questionData.question;
                        this.question = this.originalQuestion = questionData.question; 
                        this.allOptions[0] = this.originalQuestion;
                        this.questionInst = questionData.question_inst;
                        this.maxMarks = questionData.max_marks;
                        this.question_id = questionData.question_id;
                        this.nos = questionData.nos;    
                        if (questionData.media != '') {
                            this.isMedia = true;
                            if (questionData.media_type == 2) {
                                this.qimageUrl = questionData.media;
                            }
                            else if (questionData.media_type == 3) {
                                this.qaudioUrl = questionData.media;
                            }
                            else if (questionData.media_type == 4) {
                                this.qvideoUrl = questionData.media;
                            }
                        }

/*                        if (this.index in this.answerdObj) {
                            this.answer_id = this.answerdObj[this.index];
                            this.optBtnStyle(this.answer_id, this.index);
                            this.btnStyle(this.index, 'answeredCurr');
                            this.visitedQuesObj[this.index] = 'answered';
                        }
                        else {
                            this.visitedQuesObj[this.index] = 'visited';
                            this.btnStyle(this.index, 'current');
                        }*/

                        this.createOptionsObj(questionData.options);
                        this.optionData = questionData.options;
                        if(this.isTextConversion == true)
                        {
                            if(this.currentlanguage != this.primary_lang_code)
                            {
                                this.googleAPI(this.primary_lang_code, this.seclang_code);                                
                            }               
                        }  
                        /* Timer for per question */
                        this.questionAnswerTimer(questionData.time_taken);

                        /* Live Streaming */
                        //this.setliveStreaming(videoFeed);                       
                    }
                    else {
                        this.loading = false;
                        //this.router.navigateByUrl('/login');
                        this.spinner.hide();
                    }

                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
            );
    }

    /* Create array of object for number of question and lebel */
    private createArrayQuesNoObj(totalQuest, preques) {
        for (var i = 0; i < totalQuest; ++i) {
            this.questArr[i] = { index: i + 1 };
            var setColor = false;
            for (var j = 0; j < preques.length; j++) {
                if (preques[j].index === (i + 1)) {
                    var answer = preques[j].answer ? 1 : 0;
                    if (answer == 1 && preques[j].lock == 0 && setColor == false) {
                        this.btnStyle(preques[j].index, 'answered');
                        this.visitedQuesObj[preques[j].index] = 'answered';
                        setColor = true;
                    }
                    if (answer == 1 && preques[j].lock == 0 && setColor == true) {
                        this.btnStyle(preques[j].index, 'answered');
                        this.visitedQuesObj[preques[j].index] = 'answered';
                        setColor = true;
                    }
                    if (answer == 1 && preques[j].lock == 1 && setColor == false) {
                        this.btnStyle(preques[j].index, 'submited');
                        this.visitedQuesObj[preques[j].index] = 'submited';
                        setColor = true;
                    }
                    else if (answer == 1 && preques[j].lock == 1 && setColor == true) {
                        this.btnStyle(preques[j].index, 'submited');
                        this.visitedQuesObj[preques[j].index] = 'submited';
                        setColor = true;
                    }
                    if (answer == 0 && preques[j].lock == 0 && setColor == false) {
                        this.btnStyle(preques[j].index, 'visited');
                        this.visitedQuesObj[preques[j].index] = 'visited';
                        setColor = true;
                    }
                }
            }
        }
    }
    allOptions = [];
    checked: number = 0;
    /* Create question option array */
    private createOptionsObj(options) {       
        for (var i = 0; i < options.length; ++i) {
            this.allOptions[i+1] = options[i].option;           
            this.options[i] = { optiontext: options[i].option, id: options[i].option_id, type: options[i].media_type, media_url: options[i].upload_media };
            var lockOption = options[i].lock_status;
            var select_option = options[i].select_option;
            if(select_option != 0) 
            {
               //this.checked = 1;
               this.optArr.push(select_option);
               this.optCheckedArr.push(1);
            }
/*            else{
             this.checked = 0;  
            }*/ 
            this.answerString = this.optArr.toString();          
            if (lockOption == 1 && select_option) {
                /* set button background color */
                this.btnStyle(this.index, 'submited');
                /* Set question visited */
                this.visitedQuesObj[this.index] = 'submited';
                this.answer_id = select_option;
                this.answerdObj[this.index] = this.answer_id;
                this.optBtnStyle(this.answer_id, this.index);
                this.isSubmit = true;
                this.isPauseBtn = true;
                this.isResetBtn = true;
            }
            if (lockOption == 0 && select_option) {
                this.answer_id = select_option;
                this.answerdObj[this.index] = this.answer_id;
                this.btnStyle(this.index, 'answered');
                this.visitedQuesObj[this.index] = 'answered';
                this.optBtnStyle(this.answer_id, this.index);
            }
        }

        this.spinner.hide();
    }
    private convertOptionsObj(options) { //console.log(this.gstringExp);
        for (var i = 0; i < options.length; ++i) {         
            this.options[i] = { optiontext: this.gstringExp[i+1], id: options[i].option_id, type: options[i].media_type, media_url: options[i].upload_media };                
            var lockOption = options[i].lock_status;
            var select_option = options[i].select_option;
            if(select_option != 0) 
            {
               //this.checked = 1;
               this.optArr.push(select_option);
               this.optCheckedArr.push(1);
            }
/*            else{
              this.checked = 0;  
            } */
            this.answerString = this.optArr.toString();            
            if (lockOption == 1 && select_option) {
                /* set button background color */
                this.btnStyle(this.index, 'submited');
                /* Set question visited */
                this.visitedQuesObj[this.index] = 'submited';
                this.answer_id = select_option;
                this.answerdObj[this.index] = this.answer_id;
                this.optBtnStyle(this.answer_id, this.index);
                this.isSubmit = true;
                this.isPauseBtn = true;
                this.isResetBtn = true;
            }
            if (lockOption == 0 && select_option) {
                this.answer_id = select_option;
                this.answerdObj[this.index] = this.answer_id;
                this.btnStyle(this.index, 'answered');
                this.visitedQuesObj[this.index] = 'answered';
                this.optBtnStyle(this.answer_id, this.index);
            }
        }

        this.spinner.hide();
    }
    /* On index click get this question */
    public getQuestionIndex(event, item) {
        speechSynthesis.cancel();        
        if (!this.isPause && this.visitedQuesObj[item] != 'submited') {
            this.index = item;
            this.getQuestionByIndex();
        }
        this.answer_id = 0;
        this.answerString = '';
        this.optArr = [];
        this.optCheckedArr = [];                
    }

    /* On click previous button get question */
    public prevQuestion() {
        speechSynthesis.cancel();        
        if (this.index > 1 && !this.isPause) {
            let curind = this.getNextIndex('prev', this.index - 1);
            this.index = curind;
            this.getQuestionByIndex();
        }
        this.answer_id = 0;
        this.answerString = '';
        this.optArr = [];
        this.optCheckedArr = [];
    }

    /* On click next button get question */
    public nextQuestion() {
        speechSynthesis.cancel();   
/*        for (var i = 0; i < this.optCheckedArr.length; ++i) { 
            console.log(this.optCheckedArr[i]);
        } */
/*        if(this.settings['mandatory_exam'] == 1)
        {
          if(this.checked == 0)
          {
            this.checkedSwal.show(); 
            return;               
          }     
        } */   
        this.loading = true; // addintional addon
        this.spinner.show();  // addintional addon              
        if (this.index < this.totalQuestion && !this.isPause) {
            if (!this.isSubmit) {
                this.submitSingleQuestionWL();
            }
            let curind = this.getNextIndex('next', this.index + 1);
            this.index = curind; 
            this.getQuestionByIndex();
        }
        else if(this.index == this.totalQuestion && !this.isPause)
        {
            if (!this.isSubmit) {
                this.submitSingleQuestionWL();
                this.openSubmitArea();
            }
        }
        else if (!this.isPause) {
            //this.visitedQuesObj[this.index] = 'visited';
            this.openSubmitArea();
        }
        this.answer_id = 0;
        this.answerString = '';
        this.optArr = [];
        this.optCheckedArr = [];
        //this.loading = false; // addintional addon
        //this.spinner.hide(); // addintional addon   
    }

    /* On click pouse button stop timer */
    public pauseExam() {
        if (this.settings['student_pause'] == 1) {
            let status = '';
            if (this.isPause) {
                this.isPause = false;
                status = 'resume';
                document.getElementById("pauseBtn").innerHTML = '<i class="fa fa-pause-circle-o"></i> Pause';
            }
            else {
                this.isPause = true;
                status = 'pause';
                document.getElementById("pauseBtn").innerHTML = '<i class="fa fa-play-circle-o"></i> Resume';
            }
            this.spinner.show();
            this.examService.setExamPauseResume(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], status, this.settings['theory2_login'], this.settings['entered_psyc'])
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {

                        }
                        else {
                            this.loading = false;
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                        //this.router.navigateByUrl('/login');
                    }
                );
        }
    }

    /* Exam option select event */
    public optionSelected(event, indx) {
        if (!this.isPause) {
            var currentOptBtn = document.getElementById('op-' + indx) as HTMLInputElement;
            if(currentOptBtn.checked == true)
            {
                this.checked = 1;
                this.optArr.push(indx); 
            }
            else{
                this.checked = 0;
                for (var i = 0; i < this.optArr.length; i++) {
                    if (this.optArr[i] == indx)
                        this.optArr.splice(i, 1);
                }
            }            
            var allOption = document.getElementsByClassName('option-btn-style');
            if (typeof allOption != 'undefined' && allOption.length > 0) {
                for (var i = 0; i < allOption.length; ++i) {
                    /*allOption[i].classList.add('isUnchecked');*/
                    allOption[i].classList.remove('isChecked');
                }
            }

            var currentOption = event.target;
            currentOption.classList.add('isChecked');

            this.btnStyle(this.index, 'answered');

            /*set Answer id */
            this.answer_id = indx;

            /*set answer with question */
            this.answerdObj[this.index] = this.answer_id;
            for (var i = 0; i < this.notSubmitObj.length; i++) {
                if (this.notSubmitObj[i].index == this.index)
                    this.notSubmitObj.splice(i, 1);
            }

            this.answerString = this.optArr.toString(); 
            this.notSubmitObj.push({ index: this.index, answer_id: this.answerString, question_id: this.question_id, time_taken: this.timeTaken }); 
            this.visitedQuesObj[this.index] = 'answered';
        }
    }

    /* On click submit button submit current index answer */
    public submitQuestion() {
        if (!this.isPause) {
            if (this.answer_id > 0) {
                this.optionsubmitconfirmSwal.show();
            }
            else {
                this.optionsubmitSwal.show();
            }
        }
    }

    /* submit single question with lock*/
    public submitSingleQuestion() {
        this.loading = true;
        this.spinner.show();
        this.lock_status = 1;
        this.examService.setQuestionByIndexPsycho(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.index, this.answerString, this.timeTaken, this.lock_status, this.question_id, this.settings['theory2_login'], this.settings['entered_psyc'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this.btnStyle(this.index, 'submited');
                        this.visitedQuesObj[this.index] = 'submited';
                        let curind = this.getNextIndex('next', this.index + 1);
                        this.index = curind;
                        this.answerString = '';                        
                        this.getQuestionByIndex();
                    }
                    else {
                        this.loading = false;
                        //this.router.navigateByUrl('/login');
                    }
                    this.spinner.hide();
                    this.timeTaken = 0;
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
            );
    }
    /* submit single question without lock*/
    public submitSingleQuestionWL() {
        this.loading = true;
        this.spinner.show();
        this.lock_status = 0;
        this.examService.setQuestionByIndexPsycho(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.index, this.answerString, this.timeTaken, this.lock_status, this.question_id, this.settings['theory2_login'], this.settings['entered_psyc'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        //this.btnStyle(this.index, 'submited');
                        //this.visitedQuesObj[this.index] = 'submited';
                    }
                    else {
                        this.loading = false;
                        //this.router.navigateByUrl('/login');
                    }
                    this.spinner.hide();
                    this.timeTaken = 0;
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
            );
    }
    /* Change button color according to action */
    private btnStyle(btnIndex, status) {
        setTimeout(function () {
            var currentBtn = document.getElementById('btn-' + btnIndex);
            if (typeof currentBtn != 'undefined') {
                if (status == 'answered') {
                    currentBtn.classList.add('btn-answered');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-notvisited');
                    currentBtn.classList.remove('visited-btn');
                }
                else if (status == 'submited') {
                    currentBtn.classList.add('btn-submited');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-answered');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-notvisited');
                    currentBtn.classList.remove('visited-btn');
                }
                else if (status == 'visited') {
                    currentBtn.classList.add('btn-visited');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-answered');
                    currentBtn.classList.remove('btn-notvisited');
                }
                else if (status == 'answeredCurr') {
                    var preBtn = document.getElementsByClassName('btn-current');
                    //console.log(preBtn);
                    if (typeof preBtn != 'undefined' && preBtn.length > 0) {
                        for (var i = 0; i < preBtn.length; ++i) {
                            preBtn[i].classList.add('btn-visited');
                            preBtn[i].classList.remove('btn-current');
                            if (preBtn[i].classList.contains("btn-answered")) { preBtn[i].classList.remove('btn-answered'); }
                            preBtn[i].classList.remove('btn-notvisited');
                            preBtn[i].classList.remove('visited-btn');
                        }
                    }
                }
                else if (status == 'current') {
                    var preBtn = document.getElementsByClassName('visited-btn');
                    if (typeof preBtn != 'undefined' && preBtn.length > 0) {
                        for (var i = 0; i < preBtn.length; ++i) {
                            preBtn[i].classList.add('btn-visited');
                            preBtn[i].classList.remove('btn-current');
                            preBtn[i].classList.remove('btn-answered');
                            preBtn[i].classList.remove('btn-notvisited');
                            preBtn[i].classList.remove('visited-btn');
                        }
                    }
                    currentBtn.classList.add('visited-btn');
                    currentBtn.classList.add('btn-current');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-answered');
                    currentBtn.classList.remove('btn-notvisited');
                }
                else if (status == 'not-answered') {
                    currentBtn.classList.add('btn-notvisited');
                    currentBtn.classList.remove('visited-btn');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-answered');
                }
            }
        }, 200);
    }

    /* Change option btn color */
    private optBtnStyle(btnIndex, indexId) {
        setTimeout(function () {
            var currentOptBtn = document.getElementById('op-' + btnIndex) as HTMLInputElement;;
            if (typeof currentOptBtn != 'undefined') {
/*                if (currentOptBtn.classList.contains("isChecked")) { currentOptBtn.classList.remove('isChecked'); }
                currentOptBtn.classList.add('isChecked');
                currentOptBtn.classList.remove('isUnchecked');*/
                if(indexId)
                {
                    currentOptBtn.checked = true;
                }
                else{
                    if(currentOptBtn.checked == true){currentOptBtn.checked = false;}                
                }                
            }
        }, 200);
    }


    totalTimeInSec = 0;
    currentTime = 0;
    nextImageTime = 0;
    totalRandomImageNeeded = 10+((this.duration%30)*5); 


    /* Create timer according to duration */
    private counter(duration) {
/*        if(duration > 0 && duration <= 15)
            totalRandomImageNeeded = 10;
        if(duration > 15 && duration <= 30)
            totalRandomImageNeeded = 10;  */      

        var chksec = duration.toString().split(".");
        var minutes = 0;
        var seconds = 0, digits = 0;
        if (chksec.length > 1 && typeof chksec[1] != 'undefined') {
            minutes = parseInt(chksec[0]);
            digits = chksec[1].toString().length;
            if(minutes > 0)
            {
                if (digits == 1) {
                  seconds = Math.round((parseInt(chksec[1]) / 10) * 60); 
                }
                else if (digits >= 2 && digits < 3) {
                  seconds = Math.round((parseInt(chksec[1]) / 100) * 60); 
                }
                else {
                  seconds = Math.round((parseInt(chksec[1]) / 1000) * 60); 
                }        
            }
            else{
            seconds = chksec[1];
            }
        }
        else {
            var minutes = parseInt(duration);
        }

        this.totalTimeInSec = minutes * 60;
        if (minutes >= 0) {
            this.interval = setInterval(() => {

                if (!this.isPause) {

                    this.currentTime++;
//console.log(this.noofpic);
                    if (this.settings['video'] == 1) {
                        if (0 == this.currentTime % 10 && this.noofpic < 5) {
                            this.savePreExamImage();
                        }
                        //else if (this.noofpic >= 5 && this.noofpic <= 10) {
                        else if (this.noofpic >= 5) {
                            //console.log('this.nextImageTime '+this.nextImageTime);
                            //console.log('this.currentTime '+this.currentTime);
                            //console.log('this.totalTimeInSec '+this.totalTimeInSec);
                                if (this.nextImageTime < this.currentTime) {
                                    let part = ((this.totalTimeInSec - this.currentTime) / (this.noofpic > 5 ? 4 : 5));
                                    //console.log(part);
                                    this.nextImageTime = Math.floor(Math.random() * (part)) + this.currentTime;
                                    //this.savePreExamImage();
                                }
                                else if (this.currentTime == this.nextImageTime) {
                                    this.savePreExamImage();
                                }
                        }
                    }
                    --seconds;

                    minutes = (seconds < 0) ? --minutes : minutes;

                    seconds = (seconds < 0) ? 59 : seconds;

                    if (minutes == 5 && seconds == 0) {
                        document.getElementById('timer-id').classList.add('blink_me');
                    }
                    if (minutes <= 0 && seconds <= 0) {
                        clearInterval(this.interval);
                        sessionStorage.setItem('pkshn_exam_time', '0:0');
                        this.openSubmitArea();
                        this.submitFinalExam('auto');
                        this.globals.isExamOver = true;
                    }
                    else
                    {
                        this.timershow = minutes + ':' + seconds;
                        this.totalExamTime = (duration - minutes) + ':' + seconds;
                        sessionStorage.setItem('pkshn_exam_time', this.timershow);                                            
                    }



                }
            }, 1000);
        }
    }

    /* Pie chart */
    public openSubmitArea() {
        if (!this.isPause) {
            let visitedq = 0;
            let submitedq = 0;
            let answerdq = 0;
            let notAttemptq = 0;
            if (Object.keys(this.visitedQuesObj).length > 0) {
                for (let ansobj in this.visitedQuesObj) {
                    if (this.visitedQuesObj[ansobj] == 'submited')
                        submitedq++;
                    else if (this.visitedQuesObj[ansobj] == 'visited')
                        visitedq++;
                    else if (this.visitedQuesObj[ansobj] == 'answered')
                        answerdq++;
                }

                notAttemptq = this.totalQuestion - (submitedq + visitedq + answerdq);
            }
            else {
                notAttemptq = this.totalQuestion;
            }

            //this.pieChartData = [answerdq, submitedq, visitedq, notAttemptq];
            this.totalAnswered = answerdq;
            this.totalSubmited = submitedq + answerdq;
            this.totalVisited = visitedq;
            this.totalNotAnswered = notAttemptq + visitedq;
            this.pieChartData = [this.totalSubmited, this.totalNotAnswered];
            this.isDone = true;
            document.getElementById('question-area').style.display = 'none';
            document.getElementById('submited-area').style.display = 'block';
            document.getElementById('exit-test').style.display = 'none';
        }
    }

    public submitFinalAnswer() {
        if (this.settings['mandatory_exam'] == 1 && this.totalNotAnswered == 0 && this.totalVisited == 0) {
            this.examsubmitconfirmSwal.show();
        }
        else if (this.settings['mandatory_exam'] == 0) {
            this.examsubmitconfirmSwal.show();
        } else {
            this.mandatorySwal.show();
        }
    }

    public submitFinalExam(submitType) {
         
        this.loading = true;
        if (submitType == 'auto') {
            this.autoSubmitAnswers('auto');
            this.isDone = false;
        }
        else {
            this.autoSubmitAnswers('manual');
            this.isDone = true;
        }
        

    }

    public autoSubmitAnswers(submitType) {
        if (this.settings['video'] == 1) {
            var publisherObj = this.globals.publisherObj;
            publisherObj.destroy();
            var sessionObj = this.session;
            sessionObj.unpublish(publisherObj);
            //this.publisher.destroy();
        }

        var answers = [];
        var students = [{
            student_id: this.userData['id'],
            //answers: this.notSubmitObj,
            attempted: this.totalSubmited
        }];

        var studentsStr = JSON.stringify(students);
        this.spinner.show();
        this.examService.setQuestionAnswer(this.globals.root_url, this.userData['usercode'], this.settings['exam_id'], studentsStr, 1, this.totalExamTime, this.mockExam, this.totalQuestion, this.settings['theory2_login'], this.settings['entered_psyc'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this.globals.isExamOver = true;
                        if (this.settings['video'] == 1) {
                             var publisherObj = this.globals.publisherObj;
                             publisherObj.destroy();
                             //this.publisher.destroy();
                            var sessionObj = this.session;
                            sessionObj.unpublish(this.publisher);
                            //this.publisher.destroy();
                            if(this.settings['multi_face'] == 1)
                            {
                                this.saveMultiFace();
                            }
                            if(this.settings['object_found'] == 1)
                            {
                                this.saveObject();
                            }
                            if(this.settings['candidate_match'] == 1)
                            {
                                this.saveMPhotoMatch();
                            }                                                        
                        }
                        clearInterval(this.interval);
                        sessionStorage.setItem('pkshn_exam_time', '0:0');
                        if (this.settings['descriptive'] == 1) {
                            this.router.navigateByUrl('/descriptive');                           

                        }else{

                            if (submitType == 'manual') {
                                //this.router.navigateByUrl('/login');
                                document.getElementById('submited-area').style.display = 'none';
                                document.getElementById('thanks-area').style.display = 'block';
                                localStorage.removeItem('currentUser');
                                sessionStorage.removeItem("pkshn_exam_set");
                                sessionStorage.removeItem("pkshn_dexam_set");                                 
                            }
                            else {
                                document.getElementById('submited-area').style.display = 'none';
                                document.getElementById('thanks-area').style.display = 'block';
                                localStorage.removeItem('currentUser');
                                sessionStorage.removeItem("pkshn_exam_set");
                                sessionStorage.removeItem("pkshn_dexam_set");                                  
                            }
                              let that = this;
                              that.interval = setInterval(() => {
                                if(that.globals.isExamOver == true)
                                {
                                  clearInterval(that.interval); 
                                  window.location.reload();                   
                                }
                              }, 3000);                            
                        }                      
                       

                    }
                    else {
                        this.loading = false;
                        //this.router.navigateByUrl('/login');
                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                    //this.router.navigateByUrl('/login');
                }
            );

    }

    public backFromFinalSubmit() {
        document.getElementById('question-area').style.display = 'block';
        document.getElementById('submited-area').style.display = 'none';
        document.getElementById('exit-test').style.display = 'block';
    }

    /* Onclick reset btn */
    public resetAnswer() {
        if (!this.isPause) {
            var removeIndex = this.index;

            this.notSubmitObj = this.notSubmitObj.filter(function (obj) {
                if (typeof removeIndex != 'undefined')
                    return obj.index !== removeIndex;
            });
            //this.resetOptions();
            var allOption = document.getElementsByClassName('option-btn-style');
            if (typeof allOption != 'undefined' && allOption.length > 0) {
                for (var i = 0; i < allOption.length; ++i) {
                    allOption[i].classList.remove('isChecked');
                }
            }
            delete this.answerdObj[this.index];
            this.btnStyle(this.index, 'current');
            this.resetOptions(this.index);
        }
    }

    // events
    public chartClicked(e: any): void {
        console.log(e);
    }

    public chartHovered(e: any): void {
        console.log(e);
    }

    /* Check Submitted question and jump to next */
    private getNextIndex(type, index) {
        let questDb = this.visitedQuesObj;
        if (Object.keys(this.visitedQuesObj).length < 1) {
            return index;
        }
        else if (type == 'next') {
            for (var i = index; i < this.totalQuestion; ++i) {
                if (questDb[i] != 'submited')
                    return i;
            }
            if (index != 1)
                return index;
            else
                return index - 1;
        }
        else if (type == 'prev') {
            for (var i = index; i > 0; --i) {
                if (questDb[i] != 'submited')
                    return i;
            }
            return index + 1;
        }
    }

    /* Go to full screen */
    public requestFullscreen(ele) {
        if (ele.requestFullscreen) {
            ele.requestFullscreen();
        } else if (ele.webkitRequestFullscreen) {
            ele.webkitRequestFullscreen();
        } else if (ele.mozRequestFullScreen) {
            ele.mozRequestFullScreen();
        } else if (ele.msRequestFullscreen) {
            ele.msRequestFullscreen();
        } else {
            console.log('Fullscreen API is not supported.');
        }
    };

    /*to disable cut,copy and paste */

    @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
        e.preventDefault();
    }

    @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
        e.preventDefault();
    }

    @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
        e.preventDefault();
    }

    @HostListener('contextmenu', ['$event'])
    onRightClick(event) {
        event.preventDefault();
    }


    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {

        console.log(event);
        event.returnValue = false;
        event.preventDefault();


    }
    @HostListener('document:keyup', ['$event'])
    handleKeyEvent(event: KeyboardEvent) {

        console.log(event);
        event.returnValue = false;
        event.preventDefault();


    }

    //myTimeout;
    /* Text to speech */
    public textToSpeech() {
        var navUserAgent = navigator.userAgent;        
        let speechHtml = this.question + '. \n';
        for (var i = 0; i < this.options.length; ++i) {
            speechHtml += this.optionIndexText[i] + ' ? ';
            speechHtml += this.options[i].optiontext + '. \n';
        }
        speechSynthesis.cancel();
        var myTimeout = setTimeout(function () {
            speechSynthesis.pause();
            speechSynthesis.resume();
        }, 15000);          
        var msg = new SpeechSynthesisUtterance();
        var voices = window.speechSynthesis.getVoices();
        for(var i = 0; i < voices.length ; i++) {
            if(voices[i].lang == 'hi-IN')
            {
                msg.voice = voices[i];
            }
        }        
/*        if(navUserAgent.indexOf("Opera") > -1) 
        {
             //msg.voice = voices[7];
        }else if(navUserAgent.indexOf("Chrome") > -1)
        {
           msg.voice = voices[7];
        }else if(navUserAgent.indexOf("MSIE") > -1 || navUserAgent.indexOf("rv:") > -1)
        {
             //msg.voice = voices[7];
        }else if(navUserAgent.indexOf("Firefox") > -1)
        {
             //msg.voice = voices[7];
        }
        else if(navUserAgent.indexOf("Safari") > -1)
        {
             //msg.voice = voices[7];
        }
        else if(navUserAgent.indexOf("OP") > -1)
        {
             //msg.voice = voices[7];
        }  
        else if(navUserAgent.indexOf("Edg") > -1)
        {
             //msg.voice = voices[25];
        } */
        msg.volume = 1; // 0 to 1
        msg.rate = 1; // 0.1 to 10
        msg.pitch = 0; //0 to 2
        msg.text = speechHtml;
        msg.lang = this.speechLang; //hi-IN hindi india, en-GB great briten
        speechSynthesis.speak(msg);              
        msg.onend = function(e) {
          speechSynthesis.cancel();
          clearTimeout(myTimeout);
        };
    }

    /* Take photo continiously */
    // public takePicWithTimer(piceDuration) {
    //     if (this.noofpic <= 10) {
    //         var minutes = piceDuration;
    //         var seconds = 0;
    //         if (minutes >= 0) {
    //             this.interval = setInterval(() => {
    //                 if (!this.isPause) {
    //                     --seconds;
    //                     minutes = (seconds < 0) ? --minutes : minutes;

    //                     seconds = (seconds < 0) ? 59 : seconds;

    //                     if (0 == seconds % 10 && this.noofpic <= 5) {
    //                         if (this.settings['video'] == 1) {
    //                             this.savePreExamImage();
    //                         }
    //                         if (this.noofpic == 5) {
    //                             clearInterval(this.interval);
    //                         }

    //                     } else {
    //                         // if (minutes <= 0 && seconds <= 0) {
    //                         /*this.triggerSnapshot();*/
    //                         clearInterval(this.interval);
    //                         if (this.settings['video'] == 1) {
    //                             this.savePreExamImage();
    //                         }
    //                     }
    //                 }
    //             }, 1000);
    //         }
    //     }
    // }

    public savePreExamImage() {
        var publisherObj = this.globals.publisherObj;
        //var publisherObj = this.publisher;
        var imgData = publisherObj.getImgData();
        //console.log(imgData); return;
        if (imgData != '') {
            this.examService.saveExamPic(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], 'web', imgData, this.settings['theory2_login'], this.settings['entered_psyc'])
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {
                            this.noofpic++;
                            // this.takePicWithTimer(this.duration / 6);
                            this.randomPhoto = data.pic;   
                            this.runForkJoin(data.pic);                                                      
                        }
                        else if (data.status == 'COM_TOKEN_ERROR') {
                            this.loading = false;
                            this.router.navigateByUrl('/login');
                            this.spinner.hide();
                        }
                        else {
                            this.loading = false;
                        }

                    },
                    error => {
                        this.alertService.error(error);
                        this.loading = false;
                    }
                );
        }
    }
    nofaceCnt: number = 0;
    multifaceCnt: number = 0;
    objectCnt: number = 0;
    profieMatchCnt: number = 0;
    eyeBallCnt: number = 0;
    camDisableCnt: number = 0;    
    runForkJoin(randomPic) {
        const observable = forkJoin({ 
          multifacedetection: this.examService.multifaceAlertPsycho(this.globals.root_url, this.userData['usercode'], this.settings['exam_id'], this.userData['id'], randomPic),
          objectdetection: this.examService.profilematchAlertPsycho(this.globals.root_url, this.userData['usercode'], this.settings['exam_id'], this.userData['id'], randomPic),//.pipe(delay(2000), startWith(null)), // Simulate network delay
          profilematch: this.examService.multiobjectAlertPsycho(this.globals.root_url, this.userData['usercode'], this.settings['exam_id'], this.userData['id'], randomPic), //.pipe(delay(500), startWith(null)),  // Simulate network delay
        }).subscribe({
              next: (data: any) => {
                const mfd = data.multifacedetection.code;  //console.log(mfd);
                const od = data.objectdetection.code; //console.log(od);
                const pmeb = data.profilematch.code; //console.log(pmeb);
                    if(mfd === 1000)
                    {
                        this.warningStatus = data.multifacedetection.status;
                        if(this.warningStatus != '')
                            {
                                if(data.multifacedetection.id_warning == 2)
                                {
                                    this.multifaceCnt = this.multifaceCnt + 1;
                                }
                                if(data.multifacedetection.id_warning == 3)
                                {
                                    this.nofaceCnt = this.nofaceCnt + 1;
                                }                                                                
                                this.randomAlertSwal.show(); 
                            }                    
                    }
                    if(od === 1000)
                    {
                        this.warningStatus = data.objectdetection.status;
                        if(this.warningStatus != '')
                            {
                                if(data.objectdetection.id_warning == 6)
                                {
                                    this.eyeBallCnt = this.eyeBallCnt + 1;
                                }
                                if(data.objectdetection.id_warning == 4)
                                {
                                    this.profieMatchCnt = this.profieMatchCnt + 1;
                                }                                                                
                                this.randomAlertSwal.show(); 
                            }   
                    }
                    if(pmeb === 1000)
                    {
                        this.warningStatus = data.profilematch.status;
                        if(this.warningStatus != '')
                            {
                                if(data.objectdetection.id_warning == 4)
                                {
                                    this.objectCnt = this.objectCnt + 1;
                                } 
                                this.randomAlertSwal.show(); 
                            }   
                    }  
                //console.log(this.warningStatus);              
              },
              error: (err: any) => {
                console.error('Error in User API call', err);
              },
              complete: () => console.log('Completes with Success!'),
            });
    } 
    public saveMultiFace() {
        this.examService.multiface(this.globals.root_url, this.userData['usercode'], this.settings['exam_id'], this.userData['id'], this.settings['theory2_login'], this.settings['entered_psyc'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {                                                  
                    }
                    else {
                    }
                },
                error => {
                }
            );
    }
    public saveObject() {
        this.examService.multiobject(this.globals.root_url, this.userData['usercode'], this.settings['exam_id'], this.userData['id'], this.settings['theory2_login'], this.settings['entered_psyc'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {                                                  
                    }
                    else {
                    }
                },
                error => {
                }
            );
    }
    public saveMPhotoMatch() {
        this.examService.profilematch(this.globals.root_url, this.userData['usercode'], this.settings['exam_id'], this.userData['id'], this.settings['theory2_login'], this.settings['entered_psyc'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {                                                  
                    }
                    else {
                    }
                },
                error => {
                }
            );
    }        
    public gotoHome() {
        sessionStorage.setItem('pkshn_exam_time','0:0');     
        sessionStorage.removeItem("pkshn_exam_set");        
        sessionStorage.removeItem("pkshn_exam_time"); 
        sessionStorage.removeItem("pkshn_select_exam_ps");        
        sessionStorage.removeItem("pkshn_feedsetting");                         
        this.router.navigateByUrl('/userlogin');
    }

    public questionAnswerTimer(time_taken) {
        this.timeTaken = 0;
        if (typeof time_taken == 'undefined' || time_taken == null)
            time_taken = 0;

        this.timeTaken = time_taken;
        this.intervaltime = setInterval(() => {
            this.timeTaken++;
        }, 1000);
    }

    public setliveStreaming(videofeed) {
        this.sessionid = '';
        this.token = '';
        if (typeof videofeed == 'undefined' || videofeed == null) {
            this.sessionid = videofeed.session;
            this.token = videofeed.token;
        }
    }
     public saveBGlog(status) {
        this.examService.setBGlog(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.userData['userid'], this.userData['subuserid'], status, this.settings['theory2_login'], this.settings['entered_psyc'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        // do nothing
                    }
                    else {
                        // do nothing
                    }
                },
                error => {
                    this.alertService.error(error);
                }
            );
    }  
    display ='none'; //default         
    freezetext: string = '';
    theoryStausFreeze() {
            this.examService.examFreezeStatus(this.globals.root_url, this.userData['id'], this.userData['usercode'], this.settings['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    this.spinner.hide();
                    if (data.code == 1000) {
                        if (Number(data.freeze) == 1) {
                            this.isPause = true;
                            this.freezestatus = data.freeze;
                            this.freezetext = data.status; console.log(this.freezetext);
                            this.display='block';
                        }
                        else if (Number(data.freeze) == 0) {
                            this.isPause = false;
                            this.freezestatus = data.freeze;
                            this.display='none';
                        }

                    }
                    else {
                        this.loading = false;
                    }
                },
            );
    } 
    secLanguages: any;
    primary_lang_name: string;
    primary_lang_code: string;  
    examType: number = 0;
    getSecondaryLang() {
        if(this.settings['entered_psyc'] == 1)
        {
            this.examType = 7;            
        }        
            this.examService.getSecLanguages(this.globals.root_url, this.examType, this.userData['usercode'], this.settings['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    this.spinner.hide();
                    if (data.code == 1000) {
                      this.secLanguages = data.languages;
                      this.primary_lang_name = data.primary_lang_name;
                      this.primary_lang_code = data.primary_lang_code;
                      this.currentlanguage = data.primary_lang_code;
                    }
                    else {
                        this.loading = false;
                    }
                },
            );
    }  
    public resetOptions(currentindex) {
    this.examService.setResetOption(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.question_id, this.settings['theory2_login'], this.settings['entered_psyc'])
        .pipe(first())
        .subscribe(
            data => {
                if (data.code == 1000) {
                    delete this.answerdObj[currentindex];
                }
                else {
                    // do nothing
                }
            },
            error => {
                this.alertService.error(error);
            }
        );
    } 
    public setExamLogAutoSubmit(autosubmitType) {
    this.examService.setExamLogAutoSubmit(this.globals.root_url, this.userData['id'], this.userData['usercode'], this.settings['exam_id'], this.autoSubmitReason, 3, autosubmitType)
        .pipe(first())
        .subscribe(
            data => {
                if (data.code == 1000) {
                    if(!this.totalExamTime)
                    {
                        this.totalExamTime = '3';
                    }                    
                        clearInterval(this.interval);
                        clearInterval(this.apiinterval);
                        this.intervalSubscription.unsubscribe();
                        sessionStorage.setItem('pkshn_exam_time', '0:0');
                        timer(10000).subscribe(() => {
                            this.submitFinalExam('auto');        
                        });                                               
                }
                else {
                    // do nothing
                }
            },
            error => {
                console.log('An error occured.');
            }
        );
    }  
  ngOnDestroy() {
    clearInterval(this.interval);
    clearInterval(this.apiinterval);
    this.intervalSubscription.unsubscribe();
    sessionStorage.setItem('pkshn_exam_time', '0:0');
  }     
} 
